import { render, staticRenderFns } from "./campaignListItem.vue?vue&type=template&id=51942377&scoped=true"
import script from "./campaignListItem.vue?vue&type=script&lang=js"
export * from "./campaignListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51942377",
  null
  
)

export default component.exports